/*!

=========================================================
* Argon Dashboard React - v1.2.4
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Index from "views/Index.js";
import ViewExportaciones from "views/empresa/ViewExportaciones";
import ViewEmpleados from "views/empresa/ViewEmpleados";
import ViewDepartamentos from "views/empresa/ViewDepartamentos";
import ViewCentros from "views/empresa/ViewCentros";
import ViewHorarios from "views/empresa/ViewHorarios";
import ViewFestivos from "views/empresa/ViewFestivos";
import ViewCalendarios from "views/empresa/ViewCalendarios";
import ViewAddEmpleado from "views/empresa/submenus/ViewAddEmpleado";
import ViewAddDepartamento from "views/empresa/submenus/ViewAddDepartamento";
import ViewAddHorario from "views/empresa/submenus/ViewAddHorario";
import ViewAddCentro from "views/empresa/submenus/ViewAddCentro";
import ViewDetalleEmpleado from "views/empresa/detalle/ViewDetalleEmpleado";
import ViewDetalleHorarios from "views/empresa/detalle/ViewDetalleHorarios";
import Login from "views/auth/Login";
import LoginEmpresa from "views/auth/LoginEmpresa";
import ViewListEmpleadoFichajes from "views/empresa/detalle/ViewListEmpleadoFichajes";
import ViewEmpleadoFichaje from "views/empleado/ViewEmpleadoFichaje";
import ViewEmpleadoCalendario from "views/empleado/ViewEmpleadoCalendario";
import ViewEmpleadoConsultar from "views/empleado/ViewEmpleadoConsultar";
import ViewDatosEmpresa from "views/empresa/ViewDatosEmpresa";
import ViewDetalleCentro from "views/empresa/detalle/ViewDetalleCentro";
import DetalleDepartamento from "components/departamentos/DetalleDepartamento";
import ViewSolicitarVacaciones from "views/empleado/ViewSolicitarVacaciones";
import ViewAporbarVacaciones from "views/empresa/ViewAporbarVacaciones";
import ViewEmpleadoConfiguracion from "views/empleado/ViewEmpleadoConfiguracion";
import ViewVerDetalleEmpleado from "views/empresa/submenus/ViewVerDetalleEmpleado";
import ViewMotivosAusencia from "views/empresa/ViewMotivosAusencias";
import ViewIncidencias from "views/empresa/ViewPermisosAusencia";
import ViewConfiguracionEmpleado from "views/empresa/submenus/ViewCambioDeContrasennaEmpleado";
import SelectTenant from "views/auth/SelectTenant";
import ViewAsistente from "views/empresa/ViewAsistente";
import ViewEnvioInformes from "views/empresa/ViewEnvioInformes";

let adminRoutes = [
  {
    path: "/index",
    name: "Inicio",
    icon: "ni ni-tv-2 text-primary",
    component: <Index />,
    layout: "/admin",
  },
  {
    path: "/configuracion",
    name: "Configuración",
    icon: "",
    component: <ViewEmpleadoConfiguracion />,
    layout: "/admin/Configuracion",
  },
  {
    path: "/empresa",
    name: "Empresa",
    icon: "",
    component: <ViewDatosEmpresa />,
    layout: "/admin/empresa",
  },
  {
    path: "/empleados",
    name: "Empleados",
    icon: "ni ni-single-02 text-yellow",
    component: <ViewEmpleados />,
    layout: "/admin",
  },
  {
    path: "/empleados/add",
    name: "añadir empleado",
    icon: "",
    component: <ViewAddEmpleado />,
    layout: "/admin/empleados",
  },
  {
    path: "/empleados/empleado/:id",
    name: "Empleado concreto",
    icon: "",
    component: <ViewDetalleEmpleado />,
    layout: "/admin/empleados",
  },
  {
    path: "/empleados/empleado/:id/fichajes",
    name: "Fichajes empleado",
    icon: "",
    component: <ViewListEmpleadoFichajes />,
    layout: "/admin/empleados",
  },
  {
    path: "/empleados/detalle/:id",
    name: "Detalle empleados",
    icon: "",
    component: <ViewVerDetalleEmpleado />,
    layout: "/admin/empleados",
  },
  {
    path: "/empleados/configuracion/:id",
    name: "Detalle empleados",
    icon: "",
    component: <ViewConfiguracionEmpleado />,
    layout: "/admin/empleados",
  },
  {
    path: "/departamentos",
    name: "Departamentos",
    icon: "ni ni-briefcase-24 ",
    component: <ViewDepartamentos />,
    layout: "/admin",
  },
  {
    path: "/departamentos/add",
    name: "añadir departamento",
    icon: "",
    component: <ViewAddDepartamento />,
    layout: "/admin/departamentos",
  },
  {
    path: "/departamentos/departamento/:id",
    name: "Departamento concreto",
    icon: "",
    component: <DetalleDepartamento />,
    layout: "/admin/departamentos",
  },
  {
    path: "/centros",
    name: "Centros",
    icon: "ni ni-building text-blue",
    component: <ViewCentros />,
    layout: "/admin",
  },
  {
    path: "/centros/add",
    name: "añadir centro",
    icon: "",
    component: <ViewAddCentro />,
    layout: "/admin/centros",
  },
  {
    path: "/centros/centro/:id",
    name: "Centro especifico",
    icon: "",
    component: <ViewDetalleCentro />,
    layout: "/admin/centros",
  },
  {
    path: "/horarios",
    name: "Horarios",
    icon: "ni ni-watch-time text-red",
    component: <ViewHorarios />,
    layout: "/admin",
  },
  {
    path: "/horarios/add",
    name: "horarios add",
    icon: "",
    component: <ViewAddHorario />,
    layout: "/admin/horarios",
  },
  {
    path: "/horarios/horario/:id",
    name: "horario concreto",
    icon: "",
    component: <ViewDetalleHorarios />,
    layout: "/admin/horarios",
  },
  {
    path: "/calendarios",
    name: "calendarios",
    icon: "ni ni-album-2 text-yellow",
    component: <ViewFestivos />,
    layout: "/admin",
  },
  {
    path: "/agendas",
    name: "Agenda",
    icon: "ni ni-calendar-grid-58 text-red",
    component: <ViewCalendarios />,
    layout: "/admin",
  },
  {
    path: "/informes",
    name: "Informes",
    icon: "ni ni-cloud-download-95 text-green",
    component: <ViewExportaciones />,
    layout: "/admin",
  },
  {
    path: "/solicitudes/:empleadoId",
    name: "Solicitudes",
    icon: "",
    component: <ViewAporbarVacaciones />,
    layout: "/admin/solicitudes",
  },
  {
    path: "/motivosAusencia",
    name: "Motivos Ausencia",
    icon: "",
    component: <ViewMotivosAusencia />,
    layout: "/admin/solicitudes",
  },
  {
    path: "/envioInformes",
    name: "Envio de informes",
    icon: "",
    component: <ViewEnvioInformes />,
    layout: "/admin/envioInformes",
  },
  {
    path: "/asistente",
    name: "Asistente",
    icon: "",
    component: <ViewAsistente />,
    layout: "/admin/asistente",
  },
];
let userRoutes = [
  {
    path: "/index",
    name: "Fichar",
    icon: "ni ni-briefcase-24 text-yellow",
    component: <ViewEmpleadoFichaje />,
    layout: "/user",
  },
  {
    path: "/calendario",
    name: "Calendario",
    icon: "ni ni-calendar-grid-58 text-red",
    component: <ViewEmpleadoCalendario />,
    layout: "/user",
  },/*
  {
    path: "/horario",
    name: "horario",
    icon: "ni ni-badge text-red",
    component: <ViewEmpleadoHorario/>,
    layout: "/user",
  },*/
  {
    path: "/consulta",
    name: "Consulta",
    icon: "ni ni-tv-2 text-primary",
    component: <ViewEmpleadoConsultar />,
    layout: "/user",
  }  ,
  {
    path: "/vacaciones",
    name: "Vacaciones",
    icon: "ni ni-tv-2 text-success",
    component: <ViewSolicitarVacaciones />,
    layout: "/user",
  }
  ,
  {
    path: "/configuracion",
    name: "Configuracion",
    icon: "ni ni-tv-2 text-success",
    component: <ViewEmpleadoConfiguracion />,
    layout: "/user/configuracion",
  }
];
let authRoutes = [
  {
    path: "/",
    name: "Select tenant",
    icon: "ni ni-key-25 text-info",
    component: <SelectTenant />,
    layout: "/",
  },
  {
    path: "/login",
    name: "Login",
    icon: "ni ni-key-25 text-info",
    component: <Login />,
    layout: "/auth",
  },
  {
    path: "/login/empresa",
    name: "Login",
    icon: "ni ni-key-25 text-info",
    component: <LoginEmpresa />,
    layout: "/auth",
  },
  {
    path: "/login/empresa/:empresaNombre",
    name: "Login",
    icon: "ni ni-key-25 text-info",
    component: <LoginEmpresa />,
    layout: "/auth",
  }
  
];

let routes = [...adminRoutes, ...authRoutes, ...userRoutes];

export default routes;
